import {Component, Input} from '@angular/core';

@Component({
    selector: 'picture-text-card',
    templateUrl: './pictureTextCard.component.html',
    styleUrls: ['./pictureTextCard.component.scss']
})
export class PictureTextCardComponent {
    @Input() container: ContainerType = 'card';

    @Input() pictureUrl: string;

    /**
     * Use `<img>` tag when eager and use `<ion-img>` when lazy which takes advantages of the Intersection Observer internally
     * to load only when the tag is in the viewport
     */
    @Input() pictureLoadingMode: LoadingMode = 'eager';
    @Input() labelTitle: string;
    @Input() labelSubTitle: string;
    @Input() labelSubTitleHtml: string;

    constructor() {
    }
}

export type LoadingMode = 'eager' | 'lazy';
export type ContainerType = 'card' | 'none';
